import "lodash";
import { m, n, c, e, f, l, g, k, b, i, j, r, h, s, t, d } from "../CommonStringUtils-8860a016.js";
export {
  m as CommonStringUtils,
  n as CommonStringUtilsInstance,
  c as compareIgnoreCase,
  e as containsIgnoreCase,
  f as friendlyAssetName,
  l as getArticleText,
  g as getNewGuid,
  k as hashCode,
  b as includesIgnoreCase,
  i as isGuid,
  j as joinString,
  r as removeEmptyValues,
  h as removeSpecialCharacters,
  s as strEndsWith,
  t as toLowerCaseArray,
  d as toLowerCaseDictionary
};
//# sourceMappingURL=CommonStringUtils.js.map
